<template>
  <b-col cols sm="12" md="4" xl="4" class="float-left d-flex align-items-center justify-content-center flex-column">
    <p class="card-number mb-4">{{ cardOrder }}</p>
    <b-col class="mb-3 card-content">
      <img :src="imgSrc" />
      <h3 class="lg text-center mb-2 mt-2 card-title">{{ title }}</h3>
      <p class="lg text-center card-description">{{ description }}</p>
    </b-col>
  </b-col>
</template>

<script>
export default {
  name: 'interviewEmptyCard',
  props: {
    title: String,
    imgSrc: String,
    cardOrder: Number,
    description: String,
    pageType: String,
  },

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},
};
</script>

<style lang="scss">
@import '~@/style/starter.scss';
.info-card {
  min-height: 250px;
}

.card-number {
  background: #FFF;
  width: 40px;
  height: 40px;
  padding: 14px 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 500;
  line-height: 28px;
  color: $orange-primary;
}

.card-content {
  background: #FFF;
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  align-self: stretch;
  border-radius: 20px;
  border: 1px solid #E4E4E4;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  color: #353535;
}

.card-description {
  color:#858585;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}
</style>
